import { FeatureFlag } from '@ps/web-core-enums';
import { Link, Translation, useNavigate } from '@ps/web-shared-components';
import { checkUserEmail } from '@ps/web-shared-validators';
import type { ReactNode } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import Email from '../../../Email/Email';
import MarketingMailList from '../MarketingMailList/MarketingMailList';

import {
  TXTCLI_Your_email_2,
  TXTWCL_ThatXs_already_takenX_Try_Xcta_ELL,
  TXTWCL_WeXll_use_this_to_keep_in_touc_ELL,
  TXTWCL_WhatXs_your_emailX
} from './SignupEmail.messages.json';
import InfoBox from './components/InfoBox/InfoBox';

const SignupEmail: React.FC = () => {
  const { installId } = useSelector(select.session.get);
  const options = useSelector(select.cms.getRequestOptions);
  const navigate = useNavigate();
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const isSwcRMFPhoneVerificationEnabled = useFeature(FeatureFlag.SwcRMFPhoneVerification);
  const isUS = useSelector(select.cms.isSiteUS);
  const showInfoBox = isSwcRMFPhoneVerificationEnabled && isUS;

  return (
    <Container
      page={SignupEmail}
      headerProps={{ title: <Translation {...TXTCLI_Your_email_2} />, buttons: { back: true } }}
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_emailX} />}
      pageTopSubtitle={<Translation {...TXTWCL_WeXll_use_this_to_keep_in_touc_ELL} />}
    >
      <fieldset>
        {showInfoBox && <InfoBox />}
        <Email
          id="email"
          validators={[
            // @ts-ignore // TODO: fix on api consolidation
            checkUserEmail(options, installId, {
              ...TXTWCL_ThatXs_already_takenX_Try_Xcta_ELL,
              values: {
                cta: (text: ReactNode) => <Link onClick={() => navigate('/login')}>{text}</Link>
              }
            })
          ]}
          autoFocus={isAutofocusEnabled}
        />
        {<MarketingMailList />}
      </fieldset>
      <CTAButton />
    </Container>
  );
};

SignupEmail.displayName = 'SignupEmail';

export default SignupEmail;
